import {
  Grid,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core'
import LeftIcon from 'mdi-react/ChevronLeftIcon'
import RightIcon from 'mdi-react/ChevronRightIcon'
import moment from 'moment-timezone'
import { useState } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { selectAvailabilitiesByApplicant } from '../../../../selectors/applicantAvailability'
import { selectContentIdFromPathname } from '../../../../selectors/router'
import { selectShowingsInterfaceByApartmentId } from '../../../../selectors/showings'
import { getCurrentLanguage } from '../../../../translations/i18n'
import { ApplicantAvailability } from '../../../../types/applicantAvailability'
import { Showing } from '../../../../types/showings'
import {
  EmptyShowingsInterface,
  StateInterface
} from '../../../../types/states'
import { getFutureShowings } from '../../../../utils/showings/filterAndSearch'

const styles = ({ breakpoints }: Theme) => ({
  calendarContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'CircularRegular'
  },
  customCalendarContainer: {
    background: '#E7ECEF',
    borderRadius: '27px',
    padding: '21px 10px 10px 10px',
    maxHeight: '420px'
  },
  horizontalList: {
    //flexWrap: "nowrap",
    display: 'flex',
    'flex-wrap': 'wrap',
    padding: ' 1.2rem 0rem',
    '& span': {
      flex: '1 1 calc(100% / 7)',
      textAlign: 'center'
    },
    '& div': {
      textAlign: 'center',
      flex: '1 1 calc(100% / 7)'
    }
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    padding: '5px 0'
  },
  inActivelistItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    color: '#919DB5',
    padding: '5px 0',
    '& div': {
      border: '2px solid #EFF2F5',
      background: '#EFF2F5'
    }
  },
  inActiveExistinglistItem: {
    color: '#94004A'
  },
  date: {
    padding: '0.65rem 0',
    width: '59px',
    display: 'flex',
    borderRadius: '7px',
    border: '3px solid #FFFFFF',
    background: '#FFFFFF',
    [breakpoints.down(600)]: {
      width: '50px',
      padding: '0.7rem 0'
    },
    [breakpoints.down(480)]: {
      width: '36px',
      padding: '0.5rem 0'
    },
    [breakpoints.down(360)]: {
      width: '32px',
      padding: '0.4rem 0'
    }
  },
  existingDate: {
    padding: '0.65rem 0',
    width: '59px',
    display: 'flex',
    borderRadius: '7px',
    border: '3px solid #94004A',
    color: '#fff',
    background: '#94004A',
    [breakpoints.down(600)]: {
      width: '50px',
      padding: '0.7rem 0'
    },
    [breakpoints.down(480)]: {
      width: '36px',
      padding: '0.5rem 0'
    },
    [breakpoints.down(360)]: {
      width: '32px',
      padding: '0.4rem 0'
    }
  },
  selectedDate: {
    padding: '0.65rem 0',
    width: '59px',
    display: 'flex',
    borderRadius: '7px',
    border: '3px solid #94004A',
    background: '#94004A',
    color: '#ffffff',
    [breakpoints.down(600)]: {
      width: '50px',
      padding: '0.7rem 0'
    },
    [breakpoints.down(480)]: {
      width: '36px',
      padding: '0.5rem 0'
    },
    [breakpoints.down(360)]: {
      width: '32px',
      padding: '0.4rem 0'
    }
  },
  disabledDate: {
    padding: '0.65rem 0',
    width: '59px',
    display: 'flex',
    borderRadius: '7px',
    color: '#919DB5',
    border: '3px solid #EFF2F5',
    background: '#EFF2F5',
    [breakpoints.down(600)]: {
      width: '50px',
      padding: '0.7rem 0'
    },
    [breakpoints.down(480)]: {
      width: '36px',
      padding: '0.5rem 0'
    },
    [breakpoints.down(360)]: {
      width: '32px',
      padding: '0.4rem 0'
    }
  },

  dateText: {
    'text-transform': 'uppercase',
    fontSize: '0.8rem',
    color: '#919DB5'
  },
  today: {
    zIndex: 99 as const,
    fontSize: '8px',
    position: 'absolute' as const,
    top: '3px',
    color: '#000'
  },
  selectedToday: {
    zIndex: 99 as const,
    fontSize: '8px',
    position: 'absolute' as const,
    top: '3px',
    color: '#fff'
  },
  container: {
    'box-sizing': 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1.2rem'
  },
  arrows: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#919DB5'
  },
  month: {
    margin: '0rem 1.2rem',
    width: '120px',
    fontSize: '1.2rem',
    textAlign: 'center' as const,
    'text-transform': 'capitalize'
  }
})

interface CustomCalendarProps {
  input: any
  meta: any
  label: string
  custom: any
}

interface StateProps {
  existingShowings: Showing[]
  availabilities?: ApplicantAvailability[]
}

type ComponentProps = CustomCalendarProps &
  StateProps &
  WithTranslation &
  WithStyles

const SuggestCustomCalendar = ({
  input: { onChange },
  t,
  classes,
  label,
  existingShowings,
  availabilities
}: ComponentProps) => {
  moment.locale(getCurrentLanguage())
  const currentDay = moment()
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0)

  const [selectedDay, setSelectedDay]: any = useState()
  /** use to control the calendar */
  const [selectedMonth, setSelectedMonth]: any = useState(
    moment().startOf('month')
  )

  const setMonth = (action: 'back' | 'forward') => {
    if (action === 'back') {
      setSelectedMonth(moment(selectedMonth).subtract(1, 'M'))
    }
    if (action === 'forward') {
      setSelectedMonth(moment(selectedMonth).add(1, 'M'))
    }
  }
  const getDaysArray = (year: any, month: any) => {
    const monthIndex = month
    const date = new Date(year, monthIndex, 1)
    const startDate = moment(date).add(-1 * moment(date).weekday(), 'days')
    const endDate = moment(date).add(1, 'month')
    endDate.add(7 - endDate.weekday(), 'days')
    const result = []
    while (startDate < endDate) {
      result.push(startDate.clone())
      startDate.add(1, 'day')
    }
    if (result.length < 42) {
      const oldEndDate = endDate.clone()
      endDate.add(7 - endDate.weekday(), 'days')
      while (oldEndDate < endDate) {
        result.push(oldEndDate.clone())
        oldEndDate.add(1, 'day')
      }
    }
    return result
  }

  const handleOnChange = (date: any) => {
    setSelectedDay(date)
    if (date < selectedMonth) {
      setSelectedMonth(selectedMonth.clone().add(-1, 'month'))
    }
    if (date >= selectedMonth.clone().add(1, 'month')) {
      setSelectedMonth(selectedMonth.clone().add(1, 'month'))
    }
    onChange(date)
  }

  const getDateStatus = (day: any) => {
    const dayExists = () => {
      return availabilities?.find((existing) => {
        return (
          moment(existing.startDate).format('YYYY/MM/DD') ===
          day.format('YYYY/MM/DD')
        )
      })
    }

    if (selectedDay?.format('YYYY/MM/DD') === day.format('YYYY/MM/DD')) {
      return 'selectedDate'
    }
    if (moment(day).isBefore(currentDay)) {
      return 'disabledDate'
    }
    if (dayExists()) {
      return 'existingDate'
    }
    return 'date'
  }

  const getClassForDate = (state: string) => {
    switch (state) {
      case 'selectedDate':
        return classes.selectedDate
      case 'disabledDate':
        return classes.disabledDate
      case 'existingDate':
        return classes.existingDate
      default:
        return classes.date
    }
  }

  // useEffect(() => {
  //   handleOnChange(moment())
  //   // eslint-disable-next-line
  // }, [])

  return (
    <div className={classes.customCalendarContainer}>
      <Grid item xs={12} className={classes.container}>
        <div className={classes.arrows} onClick={() => setMonth('back')}>
          <LeftIcon />
        </div>
        <Typography variant='h5' className={classes.month}>
          {selectedMonth.format('MMMM')}
        </Typography>
        <div className={classes.arrows} onClick={() => setMonth('forward')}>
          <RightIcon />
        </div>
      </Grid>

      <div className={classes.calendarContainer}>
        <div className={classes.horizontalList}>
          {Array(7)
            .fill(0)
            .map((_, weekday) => {
              const day = moment().set('weekday', weekday)
              return (
                <span key={weekday} className={classes.dateText}>
                  {day.format('ddd')}
                </span>
              )
            })}
          {getDaysArray(selectedMonth.year(), selectedMonth.month()).map(
            (day) => {
              const isThisMonth: boolean = day.month() === selectedMonth.month()
              const status: string = getDateStatus(day)
              const formattedDate = day.format('YYYY/MM/DD')
              return (
                <div
                  key={formattedDate}
                  className={
                    isThisMonth ? classes.listItem : classes.inActivelistItem
                  }
                  id={formattedDate}
                  onClick={() => {
                    if (
                      status !== 'selectedDate' &&
                      status !== 'disabledDate'
                    ) {
                      handleOnChange(day)
                    }
                  }}
                >
                  {/* {formattedDate === currentDay.format('YYYY/MM/DD') && (
                    <span
                      className={
                        status === 'selectedDate'
                          ? classes.selectedToday
                          : classes.today
                      }
                    >
                      {t('general.today')}
                    </span>
                  )} */}
                  <div className={getClassForDate(status)}>
                    <span>{day.format('DD')}</span>
                  </div>
                </div>
              )
            }
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  const showingsInterface = apartmentId
    ? selectShowingsInterfaceByApartmentId(apartmentId)(state)
    : EmptyShowingsInterface

  return {
    existingShowings: getFutureShowings(showingsInterface.showings, 'reserve'),
    availabilities: selectAvailabilitiesByApplicant(state)
  }
}

export default connect(mapStateToProps)(
  withTranslation()(withStyles(styles)(SuggestCustomCalendar))
)
